import { JPF_SESSION_INFO_KEY } from "../services/constants";

const CREDIT_SYSTEM = "CREDIT_SYSTEM";
const CREDIT_EVENTS = {
  CHECKOUT_PAGE_LANDED: {
    name: "CHECKOUT_PAGE_LANDED",
    category: CREDIT_SYSTEM,
    [JPF_SESSION_INFO_KEY]: true
  },
  CHECKOUT_CHANGE_CLICKED: {
    name: "CHECKOUT_CHANGE_CLICKED",
    category: CREDIT_SYSTEM
  },
  CHECKOUT_RADIO_TOGGLE: {
    name: "CHECKOUT_RADIO_TOGGLE",
    category: CREDIT_SYSTEM
  },
  CHECKOUT_PAY_CLICKED: {
    name: "CHECKOUT_PAY_CLICKED",
    category: CREDIT_SYSTEM
  },
  CHECKOUT_NAV_CLICKED: {
    name: "CHECKOUT_NAV_CLICKED",
    category: CREDIT_SYSTEM
  },
  TRANSACTION_ERROR: {
    name: "TRANSACTION_ERROR",
    category: CREDIT_SYSTEM
  },
  TRANSACTION_INITIATE_SUCCESS: {
    name: "TRANSACTION_INITIATE_SUCCESS",
    category: CREDIT_SYSTEM
  },
  CHECKOUT_REDIRECTION: {
    name: "CHECKOUT_REDIRECTION",
    category: CREDIT_SYSTEM
  },
  CHECKOUT_LANDED_TRANSACTION_ID: {
    name: "CHECKOUT_WITH_TRANSACTION_ID",
    category: CREDIT_SYSTEM
  },
  CHECKOUT_SKU_SUBMIT: {
    name: "CHECKOUT_SKU_SUBMIT",
    category: CREDIT_SYSTEM
  },
  CHECKOUT_EXPLORE_CLICKED: {
    name: "CHECKOUT_EXPLORE_CLICKED",
    category: CREDIT_SYSTEM
  },
  PLAN_SELECTION_BUY_CLICKED: {
    name: "PLAN_SELECTION_BUY_CLICKED",
    category: CREDIT_SYSTEM
  },
  PLAN_SELECTION_PAGE_LANDED: {
    name: "PLAN_SELECTION_PAGE_LANDED",
    category: CREDIT_SYSTEM
  },
  JOB_PLAN_SELECTION_PAGE_LANDED: {
    name: "JOB_PLAN_SELECTION_PAGE_LANDED",
    category: CREDIT_SYSTEM,
    [JPF_SESSION_INFO_KEY]: true
  },
  JOB_PLAN_CHANGED: {
    name: "JOB_PLAN_CHANGED",
    category: CREDIT_SYSTEM
  },
  JOB_PLAN_SELECTION_BACK_CLICKED: {
    name: "JOB_PLAN_SELECTION_BACK_CLICKED",
    category: CREDIT_SYSTEM
  },

  JOB_PLAN_SELECTION_CONFIRM_POPUP_LANDED: {
    name: "JOB_PLAN_SELECTION_CONFIRM_POPUP_LANDED",
    category: CREDIT_SYSTEM,
    [JPF_SESSION_INFO_KEY]: true
  },
  DRAFT_JOB_CREATED: {
    name: "DRAFT_JOB_CREATED",
    category: CREDIT_SYSTEM,
    [JPF_SESSION_INFO_KEY]: true
  },
  TRANSACTION_HISTORY_LANDED: {
    name: "TRANSACTION_HISTORY_LANDED",
    category: CREDIT_SYSTEM
  },
  TH_REFRESH_CLICKED: {
    name: "TH_REFRESH_CLICKED",
    category: CREDIT_SYSTEM
  },
  TH_RESERVED_CLICKED: {
    name: "TH_RESERVED_CLICKED",
    category: CREDIT_SYSTEM
  },
  TH_DATE_FILTER_CLICKED: {
    name: "TH_DATE_FILTER_CLICKED",
    category: CREDIT_SYSTEM
  },
  TH_DATE_FILTER_SELECTED: {
    name: "TH_DATE_FILTER_SELECTED",
    category: CREDIT_SYSTEM
  },
  TH_TAB_CLICKED: {
    name: "TH_TAB_CLICKED",
    category: CREDIT_SYSTEM
  },
  TH_PAGE_CLICKED: {
    name: "TH_PAGE_CLICKED",
    category: CREDIT_SYSTEM
  },
  TH_NO_TRANSACTION_LANDED: {
    name: "TH_NO_TRANSACTION_LANDED",
    category: CREDIT_SYSTEM
  },
  TH_GO_TO_HOME_CLICKED: {
    name: "TH_GO_TO_HOME_CLICKED",
    category: CREDIT_SYSTEM
  },
  TH_RESERVED_BACK_TO_TH_CLICKED: {
    name: "TH_RESERVED_BACK_TO_TH_CLICKED",
    category: CREDIT_SYSTEM
  },
  TRANSACTION_STATUS_PAGE_LANDED: {
    name: "TRANSACTION_STATUS_PAGE_LANDED",
    category: CREDIT_SYSTEM
  },
  PAYMENT_SUCCESS_EMAIL_CLICKED: {
    name: "PAYMENT_SUCCESS_EMAIL_CLICKED",
    category: CREDIT_SYSTEM
  },
  PAYMENT_SUCCESS_VIEW_ALL_JOBS: {
    name: "PAYMENT_SUCCESS_VIEW_ALL_JOBS",
    category: CREDIT_SYSTEM
  },
  PAYMENT_SUCCESS_HOME_CLICKED: {
    name: "PAYMENT_SUCCESS_HOME_CLICKED",
    category: CREDIT_SYSTEM
  },
  PAYMENT_SUCCESS_POST_JOB_CLICKED: {
    name: "PAYMENT_SUCCESS_POST_JOB_CLICKED",
    category: CREDIT_SYSTEM
  },
  PAYMENT_PENDING_T_HISTORY_CLICKED: {
    name: "PAYMENT_PENDING_T_HISTORY_CLICKED",
    category: CREDIT_SYSTEM
  },
  PAYMENT_FAILED_RETRY_CLICKED: {
    name: "PAYMENT_FAILED_RETRY_CLICKED",
    category: CREDIT_SYSTEM
  },
  BUY_CREDITS_CLICKED: {
    name: "BUY_CREDITS_CLICKED",
    category: "CREDIT_SYSTEM"
  },
  CHECKOUT_GST_DROPDOWN_CLICKED: {
    name: "CHECKOUT_PAGE_GST_DROPDOWN_CLICKED",
    category: CREDIT_SYSTEM
  },
  CHECKOUT_GST_SUGGESTION_SELECTED: {
    name: "CHECKOUT_PAGE_GST_SUGGESTION_SELECTED",
    category: CREDIT_SYSTEM
  },
  CHECKOUT_PAGE_GST_INVALID: {
    name: "CHECKOUT_PAGE_GST_INVALID",
    category: CREDIT_SYSTEM
  },
  CHECKOUT_PAGE_GST_EMPTY_STATE: {
    name: "CHECKOUT_PAGE_GST_EMPTY_STATE",
    category: CREDIT_SYSTEM
  },
  CHECKOUT_JOB_PLAN_CHANGED: {
    name: "CHECKOUT_JOB_PLAN_CHANGED",
    category: CREDIT_SYSTEM
  },
  DASHBOARD_UPGRADE_TO_PREMIUM_CLICK: {
    name: "DASHBOARD_UPGRADE_TO_PREMIUM_CLICK",
    category: CREDIT_SYSTEM
  },
  COHORT_LIMIT_VIEW_CANDIDATES_CLICK: {
    name: "COHORT_LIMIT_VIEW_CANDIDATES_CLICK",
    category: CREDIT_SYSTEM
  },
  COHORT_LIMIT_SUFFICIENT_CREDIT_LANDED: {
    name: "COHORT_LIMIT_SUFFICIENT_CREDIT",
    category: CREDIT_SYSTEM
  },
  UPGRADE_SUFFICIENT_CREDIT_LANDED: {
    name: "UPGRADE_SUFFICIENT_CREDIT_LANDED",
    category: CREDIT_SYSTEM
  },
  COHORT_LIMIT_INSUFF_CREDIT_LANDED: {
    name: "COHORT_LIMIT_INSUFF_CREDIT_LANDED",
    category: CREDIT_SYSTEM
  },
  UPGRADE_LIMIT_INSUFF_CREDIT_LANDED: {
    name: "UPGRADE_LIMIT_INSUFF_CREDIT_LANDED",
    category: CREDIT_SYSTEM
  },
  COHORT_SUFF_CREDIT_DISMISS: {
    name: "COHORT_SUFF_CREDIT_DISMISS",
    category: CREDIT_SYSTEM
  },
  UPGRADE_SUFF_CREDIT_DISMISS: {
    name: "UPGRADE_SUFF_CREDIT_DISMISS",
    category: CREDIT_SYSTEM
  },
  COHORT_SUFFI_CREDIT_LANDED_CONFIRM: {
    name: "COHORT_SUFFI_CREDIT_LANDED_CONFIRM",
    category: CREDIT_SYSTEM
  },
  UPGRADE_SUFFI_CREDIT_LANDED_CONFIRM: {
    name: "UPGRADE_SUFFI_CREDIT_LANDED_CONFIRM",
    category: CREDIT_SYSTEM
  },
  COHORT_IN_SUFF_CREDIT_DISMISS: {
    name: "COHORT_IN_SUFF_CREDIT_DISMISS",
    category: CREDIT_SYSTEM
  },
  UPGRADE_IN_SUFF_CREDIT_DISMISS: {
    name: "UPGRADE_IN_SUFF_CREDIT_DISMISS",
    category: CREDIT_SYSTEM
  },
  COHORT_IN_SUFF_BUY_CREDITS: {
    name: "COHORT_IN_SUFF_BUY_CREDITS",
    category: CREDIT_SYSTEM
  },
  UPGRADE_IN_SUFF_BUY_CREDITS: {
    name: "UPGRADE_IN_SUFF_BUY_CREDITS",
    category: CREDIT_SYSTEM
  },
  URGENT_HIRING_HOVER_POPUP_SHOWN: {
    name: "URGENT_HIRING_HOVER_POPUP_SHOWN",
    category: CREDIT_SYSTEM
  },
  COHORT_JOB_POSTING_POPUP_SHOWN: {
    name: "COHORT_JOB_POSTING_POPUP_SHOWN",
    category: CREDIT_SYSTEM
  },
  COHORT_JOB_POSTING_POPUP_DISMISS: {
    name: "COHORT_JOB_POSTING_POPUP_DISMISS",
    category: CREDIT_SYSTEM
  },
  BASIC_JOB_EXHAUSTED_POPUP_SHOWN: {
    name: "BASIC_JOB_EXHAUSTED_POPUP_SHOWN",
    category: CREDIT_SYSTEM
  },
  BASIC_JOB_EXHAUSTED_POPUP_DISMISS: {
    name: "BASIC_JOB_EXHAUSTED_POPUP_DISMISS",
    category: CREDIT_SYSTEM,
    [JPF_SESSION_INFO_KEY]: true
  },
  PREMIUM_JOB_POST_FROM_POPUP: {
    name: "PREMIUM_JOB_POST_FROM_POPUP",
    category: CREDIT_SYSTEM
  },
  /* Nitya Event Start */
  CREDIT_SELECTION_CONTACT_SALES_CLICKED: {
    name: "CREDIT_SELECTION_CONTACT_SALES_CLICKED",
    category: CREDIT_SYSTEM
  },
  CONTACT_SALES_CLICKED_V2: {
    name: "CONTACT_SALES_CLICKED_V2",
    category: CREDIT_SYSTEM
  },
  CREDIT_SELECTION_VIEW_ALL_FAQ_CLICKED: {
    name: "CREDIT_SELECTION_VIEW_ALL_FAQ_CLICKED",
    category: CREDIT_SYSTEM
  },
  SALES_POP_UP_INCOMPLETE_DETAILS_ERROR: {
    name: "SALES_POP_UP_INCOMPLETE_DETAILS_ERROR",
    category: CREDIT_SYSTEM
  },
  SALES_POP_UP_SEND_CLICKED: {
    name: "SALES_POP_UP_SEND_CLICKED",
    category: CREDIT_SYSTEM
  },
  SALES_POP_UP_PHONE_CLICKED: {
    name: "SALES_POP_UP_PHONE_CLICKED",
    category: CREDIT_SYSTEM
  },
  SALES_POP_UP_EMAIL_CLICKED: {
    name: "SALES_POP_UP_EMAIL_CLICKED",
    category: CREDIT_SYSTEM
  },
  SALES_POP_UP_DISMISS_CLICKED: {
    name: "SALES_POP_UP_DISMISS_CLICKED",
    category: CREDIT_SYSTEM
  },
  DASHBOARD_CREDIT_RESERVED_HOVER: {
    name: "DASHBOARD_CREDIT_RESERVED_HOVER",
    category: CREDIT_SYSTEM
  },
  EXPIRING_CREDIT_POST_JOB_CLICKED: {
    name: "EXPIRING_CREDIT_POST_JOB_CLICKED",
    category: CREDIT_SYSTEM
  },
  EXPIRING_CREDITS_SHOWN: {
    name: "EXPIRING_CREDITS_SHOWN",
    category: CREDIT_SYSTEM
  },
  DASHBOARD_CREDIT_EDUCATION_STICKY_SHOWN: {
    name: "DASHBOARD_CREDIT_EDUCATION_STICKY_SHOWN",
    category: CREDIT_SYSTEM
  },
  DASHBOARD_CREDIT_EDUCATION_STICKY_DISMISS: {
    name: "DASHBOARD_CREDIT_EDUCATION_STICKY_DISMISS",
    category: CREDIT_SYSTEM
  },
  DASHBOARD_MONTHLY_BASIC_JOB_ADDITION_STICKY_SHOWN: {
    name: "DASHBOARD_MONTHLY_BASIC_JOB_ADDITION_STICKY_SHOWN",
    category: CREDIT_SYSTEM
  },
  DASHBOARD_MONTHLY_BASIC_JOB_ADDITION_STICKY_DISMISS: {
    name: "DASHBOARD_MONTHLY_BASIC_JOB_ADDITION_STICKY_DISMISS",
    category: CREDIT_SYSTEM
  },
  DASHBOARD_CREDIT_FIRST_TIME_LOGIN_LANDED: {
    name: "DASHBOARD_CREDIT_FIRST_TIME_LOGIN_LANDED",
    category: CREDIT_SYSTEM
  },
  DASHBOARD_CREDIT_FIRST_TIME_LOGIN_DISMISS: {
    name: "DASHBOARD_CREDIT_FIRST_TIME_LOGIN_DISMISS",
    category: CREDIT_SYSTEM
  },
  DASHBOARD_CREDIT_FIRST_TIME_LOGIN_GET_STARTED_CLICKED: {
    name: "DASHBOARD_CREDIT_FIRST_TIME_LOGIN_GET_STARTED_CLICKED",
    category: CREDIT_SYSTEM
  },
  CREDIT_SELECTION_STEPPER_POS: {
    name: "CREDIT_SELECTION_STEPPER_POS",
    category: CREDIT_SYSTEM
  },
  CREDIT_SELECTION_STEPPER_NEG: {
    name: "CREDIT_SELECTION_STEPPER_NEG",
    category: CREDIT_SYSTEM
  },
  JOB_PLAN_SELECTION_SAVE_JOB_CLICKED: {
    name: "JOB_PLAN_SELECTION_SAVE_JOB_CLICKED",
    category: CREDIT_SYSTEM
  },
  JOB_PLAN_CONFIRM_POPUP_DISMISSED: {
    name: "JOB_PLAN_CONFIRM_POPUP_DISMISSED",
    category: CREDIT_SYSTEM,
    [JPF_SESSION_INFO_KEY]: true
  },
  JOB_PLAN_SELECTION_POPUP_CONFIRM_CLICKED: {
    name: "JOB_PLAN_SELECTION_POPUP_CONFIRM_CLICKED",
    category: CREDIT_SYSTEM,
    [JPF_SESSION_INFO_KEY]: true
  },
  DASHBOARD_COMPLETE_DRAFT_CLICKED: {
    name: "DASHBOARD_COMPLETE_DRAFT_CLICKED",
    category: CREDIT_SYSTEM
  },
  PROFILE_TRANSACTION_HISTORY_CLICKED: {
    name: "PROFILE_TRANSACTION_HISTORY_CLICKED",
    category: CREDIT_SYSTEM
  },
  BLACKLIST_REC_PURCHASE_POP_UP_SHOWN: {
    name: "BLACKLIST_REC_PURCHASE_POP_UP_SHOWN",
    category: CREDIT_SYSTEM
  },
  BLACKLIST_REC_PURCHASE_POP_UP_CLOSED: {
    name: "BLACKLIST_REC_PURCHASE_POP_UP_CLOSED",
    category: CREDIT_SYSTEM
  },
  BLACKLIST_REC_JOB_POST_POP_UP_SHOWN: {
    name: "BLACKLIST_REC_JOB_POST_POP_UP_SHOWN",
    category: CREDIT_SYSTEM,
    [JPF_SESSION_INFO_KEY]: true
  },
  BLACKLIST_REC_JOB_POST_POP_UP_CLOSED: {
    name: "BLACKLIST_REC_JOB_POST_POP_UP_CLOSED",
    category: CREDIT_SYSTEM,
    [JPF_SESSION_INFO_KEY]: true
  },
  BLACKLIST_REC_JOB_POST_POP_UP_DISMISS: {
    name: "BLACKLIST_REC_JOB_POST_POP_UP_DISMISS",
    category: CREDIT_SYSTEM,
    [JPF_SESSION_INFO_KEY]: true
  },
  JOB_PLAN_SELECTION_DETAILS_ERROR: {
    name: "JOB_PLAN_SELECTION_DETAILS_ERROR",
    category: CREDIT_SYSTEM,
    [JPF_SESSION_INFO_KEY]: true
  },
  SALES_POPUP_NUMBER: {
    name: "SALES_POPUP_NUMBER",
    category: CREDIT_SYSTEM
  },
  SALES_POPUP_EMAIL: {
    name: "SALES_POPUP_EMAIL",
    category: CREDIT_SYSTEM
  },
  CHECKOUT_ERR_PHONE_CLCKED: {
    name: "CHECKOUT_ERR_PHONE_CLCKED",
    category: CREDIT_SYSTEM
  },
  CHECKOUT_ERR_EMAIL_CLCKED: {
    name: "CHECKOUT_ERR_EMAIL_CLCKED",
    category: CREDIT_SYSTEM
  },
  TRIAL_BAR_CROSS: {
    name: "TRIAL_BAR_CROSS",
    category: CREDIT_SYSTEM
  },
  CHECKOUT_BROWSER_BACK: {
    name: "CHECKOUT_BROWSER_BACK",
    category: CREDIT_SYSTEM
  },
  CHECKOUT_EXIT_POPUP: {
    name: "CHECKOUT_EXIT_POPUP",
    category: CREDIT_SYSTEM
  },
  CAMPAIGN_BANNER_CLICKED: {
    name: "CAMPAIGN_BANNER_CLICKED",
    category: CREDIT_SYSTEM
  },
  GST_POLLING_DAILY_LIMIT_REACHED: {
    name: "GST_POLLING_DAILY_LIMIT_REACHED",
    category: CREDIT_SYSTEM
  },
  GST_POLLING_CONFIRM_CLICKED: {
    name: "GST_POLLING_CONFIRM_CLICKED",
    category: CREDIT_SYSTEM
  },
  GET_EMAIL_INVOICE_CLICKED: {
    name: "GET_EMAIL_INVOICE_CLICKED",
    category: CREDIT_SYSTEM
  },
  INVOICE_EMAIL_EDIT_CLICKED: {
    name: "INVOICE_EMAIL_EDIT_CLICKED",
    category: CREDIT_SYSTEM
  },
  INVOICE_EMAIL_UPDATE_SUCCESS: {
    name: "INVOICE_EMAIL_UPDATE_SUCCESS",
    category: CREDIT_SYSTEM
  },
  ACTION_NAVIGATION: {
    name: "ACTION_NAVIGATION",
    category: CREDIT_SYSTEM
  },
  PLAN_SELECTION_ARROW_CLICKED: {
    name: "PLAN_SELECTION_ARROW_CLICKED",
    category: CREDIT_SYSTEM
  }
};

export default CREDIT_EVENTS;
